import { render, staticRenderFns, recyclableRender, components } from "./vk-u-verification-code.vue?vue&type=template&id=117df9cd&scoped=true&"
var renderjs
import script from "./vk-u-verification-code.vue?vue&type=script&lang=js&"
export * from "./vk-u-verification-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117df9cd",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/vk-unicloud/components/vk-u-verification-code/vk-u-verification-code.vue"
export default component.exports